const en = {
  full_name: "Name",
  address: "Address",
  email_address: "email address",
  please_check_i_agree: "Please check \"I agree\"!",
  please_enter_your_email_address_correctly: "Enter a correct email address",
  please_enter_your_email_address: "Please enter your email address",
  please_register_the_delivery_address_information_of_the_cash_voucher: "Please register the delivery address information of the cash voucher.",
  after_the_lottery_we_will_send_the_coupon_to_your_registered_address: "After the lottery, we will send the coupon to your registered address.",
  notice_and_consent_statement_regarding_our_handling_of_personal_information: "Our company’s Notice and Agreement for the Handling of Personal Information",
  please_agree_to_and_proceed_to_registration: "Proceed to registration after agreeing to the policy",
  thank_you_for_registering: "Thank you for registering.",
  winners_will_be_selected_by_a_strict_lottery_and_will_be_notified_by_mail: "Winners will be selected by a strict lottery, and will be notified by mail."
}
export default  en;